import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_chip = _resolveComponent("v-chip");
    return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentFilterItems, (filter, index) => {
        return (_openBlock(), _createElementBlock("div", {
            class: "d-inline-block mr-2",
            key: index
        }, [
            _createVNode(_component_v_chip, {
                color: "primary",
                variant: "flat",
                "append-icon": "icon-cancel-circled",
                onClick: ($event) => (_ctx.clearFilter(filter.numericValue))
            }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(filter.displayValue), 1)
                ]),
                _: 2
            }, 1032, ["onClick"])
        ]));
    }), 128));
}
